export const toDateString = (date: Date) => {
  if (!date) return
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const formatDate = (dateStr?: string) => {
  if (!dateStr) return ''

  const date = new Date(dateStr)

  return new Intl.DateTimeFormat('ru-RU', {
    weekday: 'short',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(date)
}

export const formatDateToApi = (date: Date) =>
  [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-')

export const getTeamStartTime = (
  roomStartsAt: string | Date,
  minutesForTeam: number,
  presentationOrder: number
): string => {
  const base = typeof roomStartsAt === 'string' ? new Date(roomStartsAt) : roomStartsAt
  const time = new Date(base.getTime() + (presentationOrder - 1) * minutesForTeam * 60_000)
  return time.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

export const formatTime = (date: Date) => {
  return date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}
